import { readableColor, transparentize, opacify, darken, rgba, tint } from 'polished';
import { Theme } from 'styled-components';
import {
  STATUS_CONFIRMED,
  STATUS_CANCELLED,
  STATUS_ACTIVE,
  STATUS_COMPLETED,
  STATUS_CLAIM_STARTED,
} from '../constants';
import { IColorModifierHelperFunction, IThemePropertyGetter } from '../types';

export const gray: IThemePropertyGetter<keyof Theme['grays']> = (colorName) => ({ theme }) => theme.grays[colorName];
export const color: IThemePropertyGetter<keyof Theme['colors']> = (colorName) => ({ theme }) =>
  theme.colors[colorName];
export const themeColor: IThemePropertyGetter<keyof Theme['themeColors']> = (colorName) => ({ theme }) =>
  theme.themeColors[colorName];

/**
 * Function to return a either dark or light color based on background color
 * to make it readable. Currently this function needs light and dark vars in
 * themeColors but that doesn't exist yet
 */
export const colorYIQ = (backgroundColor: any) => ({
  theme: {
    themeColors: { light, dark },
  },
}: any) => (readableColor(backgroundColor) === '#000' ? dark : light);

export const transparentizeColor: IColorModifierHelperFunction = (amount, colorValue) => ({ theme }) => {
  const parsedColor = (typeof colorValue === 'function' ? colorValue({ theme }) : colorValue) as string;
  const parsedAmount = typeof amount === 'function' ? amount({ theme }) : amount;
  return transparentize(parsedAmount, parsedColor);
};

export const opacifyColor: IColorModifierHelperFunction = (amount, colorValue) => ({ theme }) => {
  const parsedColor = (typeof colorValue === 'function' ? colorValue({ theme }) : colorValue) as string;
  const parsedAmount = typeof amount === 'function' ? amount({ theme }) : amount;
  return opacify(parsedAmount, parsedColor);
};

export const darkenColor: IColorModifierHelperFunction = (amount, colorValue) => ({ theme }) => {
  const parsedColor = (typeof colorValue === 'function' ? colorValue({ theme }) : colorValue) as string;
  const parsedAmount = typeof amount === 'function' ? amount({ theme }) : amount;
  return darken(parsedAmount, parsedColor);
};

export const tintColor: IColorModifierHelperFunction = (amount, colorValue) => ({ theme }) => {
  const parsedColor = (typeof colorValue === 'function' ? colorValue({ theme }) : colorValue) as string;
  const parsedAmount = typeof amount === 'function' ? amount({ theme }) : amount;
  return tint(parsedAmount, parsedColor);
};

export const rgbaColor: IColorModifierHelperFunction = (amount, colorValue) => ({ theme }) => {
  const parsedColor = typeof colorValue === 'function' ? colorValue({ theme }) : colorValue;
  const parsedAmount = (typeof amount === 'function' ? amount({ theme }) : amount) as number;
  return rgba(parsedColor, parsedAmount);
};

export const statusColor: IThemePropertyGetter<string> = (status) => ({ theme }) => {
  const { success, danger, warning, completed } = theme.themeColors;
  const colors = {
    [STATUS_ACTIVE]: success,
    [STATUS_CANCELLED]: danger,
    [STATUS_COMPLETED]: completed,
    [STATUS_CONFIRMED]: warning,
    [STATUS_CLAIM_STARTED]: warning,
  };

  return colors[status as keyof typeof colors];
};
